(() => {
  const STORAGE_KEY = 'smb_wishlist_variants';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch {
      return [];
    }
  }

  function saveWishlist(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    window.dispatchEvent(
      new CustomEvent('wishlist:updated', { detail: { wishlist: list } })
    );
  }

  function add({ variant_id, product_handle }) {
    const list = getWishlist();
    if (!list.some(i => i.variant_id === variant_id)) {
      list.push({ variant_id, product_handle });
      saveWishlist(list);
    }
  }

  function remove(variant_id) {
    saveWishlist(getWishlist().filter(i => i.variant_id !== variant_id));
  }

  function toggle({ variant_id, product_handle }) {
    has(variant_id)
      ? remove(variant_id)
      : add({ variant_id, product_handle });
  }

  function has(variant_id) {
    return getWishlist().some(i => i.variant_id === variant_id);
  }

  window.SMBWishlist = { get: getWishlist, add, remove, toggle, has };
})();

//   document.addEventListener('click', (e) => {
//     const btn = e.target.closest('[data-wishlist-toggle]');
//     if (!btn || !window.SMBWishlist) return;
//      e.preventDefault();
//      e.stopPropagation();
//     const variant_id = Number(btn.dataset.variantId);
//     const product_handle = btn.dataset.productHandle;

//     // SMBWishlist.toggle({ variant_id, product_handle });

//     // const isActive = SMBWishlist.has(variant_id);
//     // btn.setAttribute('aria-pressed', String(isActive));
//     // btn.classList.toggle('is-active', isActive);

//     const wasActive = btn.classList.contains('is-active');


// btn.classList.toggle('is-active', !wasActive);
// btn.setAttribute('aria-pressed', String(!wasActive));

// if (wasActive) {
//   SMBWishlist.remove(variant_id);
// } else {
//   SMBWishlist.add({ variant_id, product_handle });
// }
//   });
  document.addEventListener('click', (e) => {
  
  const btn = e.target.closest('[data-wishlist-toggle]');
  if (!btn || !window.SMBWishlist) return;
   if (!btn.contains(e.target)) return;
  const card = btn.closest('product-card');
if (card) {
  card.dataset.wishlistLock = 'true';
}

  e.preventDefault();
  e.stopPropagation();

  if (btn.dataset.busy === 'true') return;
  btn.dataset.busy = 'true';

  const variant_id = Number(btn.dataset.variantId);
  const product_handle = btn.dataset.productHandle;

  const wasActive = btn.classList.contains('is-active');

  // UI ottimistica immediata
  btn.classList.toggle('is-active', !wasActive);
  btn.setAttribute('aria-pressed', String(!wasActive));

  // storage
  if (wasActive) {
    SMBWishlist.remove(variant_id);
  } else {
    SMBWishlist.add({ variant_id, product_handle });
  }

  requestAnimationFrame(() => {
      if (card) delete card.dataset.wishlistLock;
  delete btn.dataset.busy;
  });
});
document.addEventListener('pointerdown', (e) => {
  const btn = e.target.closest('[data-wishlist-toggle]');
  if (!btn) return;

  e.preventDefault();
  e.stopPropagation();
}, { capture: true });

  window.addEventListener('DOMContentLoaded', () => {
    if (!window.SMBWishlist) return;

    document.querySelectorAll('[data-wishlist-toggle]').forEach((btn) => {
      const variant_id = Number(btn.dataset.variantId);
      const isActive = SMBWishlist.has(variant_id);
      btn.setAttribute('aria-pressed', String(isActive));
      btn.classList.toggle('is-active', isActive);
    });
  });